import React, { useEffect } from 'react';
import {
  ActionIcon,
  Button,
  Group,
  Text,
  Tooltip
} from '@mantine/core';
import { IconCloudUpload, IconFileDownload, IconFilter, IconFilterFilled, IconPlus, IconRefresh } from '@tabler/icons-react';
import { estadoInicialMaterial, type ITablaMaterialesVistaProps } from '../interfaces';
import Tabla from '../../../globales/componentes/tabla/tabla';
import FiltroMaterialesVista from './filtroMaterialesVista';
import type { ITipoMaterial } from '../../../modelos/Materiales/entidades/ITipoMaterial';

interface ITablaMaterialesVistaPropsExtendida extends ITablaMaterialesVistaProps {
  modoEdicionLinea?: boolean;
  filaEnEdicion?: number | null; // ✅ Cambiar a number
  tiposMateriales: ITipoMaterial[];
  descargarPlantilla: () => Promise<void>;
  cargaMasivaMateriales: () => void;
}

const TablaMaterialesVista: React.FunctionComponent<ITablaMaterialesVistaPropsExtendida> = ({
  tabla,
  abrirModalMaterial,
  consultarMateriales,
  filtro,
  manejarCambioFiltroMaterial,
  habilitarFiltros,
  manejarHabilitarFiltros,
  modoEdicionLinea = false,
  filaEnEdicion = null,
  tiposMateriales,
  descargarPlantilla,
  cargaMasivaMateriales,
  limpiarFiltros
}) => {

  useEffect(() => {
    consultarMateriales(filtro, { Page: tabla.getState().pagination.pageIndex, Size: tabla.getState().pagination.pageSize });
  }, [])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, overflowX: 'hidden' }}>
      <Group justify="space-between" mb="md">
        <Text fw={700} size="lg">Materiales</Text>
        <Group>
          <Group gap={4}>
            <Tooltip
              label="Refrescar"
              withinPortal
              openDelay={100}
              zIndex={9999}
              style={{ fontSize: '10px', padding: '3px 5px' }}
            >
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={() => consultarMateriales(estadoInicialMaterial, { Page: tabla.getState().pagination.pageIndex, Size: tabla.getState().pagination.pageSize })}
                disabled={filaEnEdicion !== null}
              >
                <IconRefresh size={16} />
              </ActionIcon>
            </Tooltip>
            <Tooltip
              label="Filtrar"
              withinPortal
              openDelay={100}
              zIndex={9999}
              style={{ fontSize: '10px', padding: '3px 5px' }}
            >
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={() => manejarHabilitarFiltros(!habilitarFiltros)}
                disabled={filaEnEdicion !== null}
              >
                {habilitarFiltros ? <IconFilterFilled size={16} /> : <IconFilter size={16} />}
              </ActionIcon>
            </Tooltip>
            <Tooltip zIndex={100000} label="Descargar Plantilla" style={{ fontSize: '10px', padding: '3px 5px' }} withinPortal openDelay={100}>
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={descargarPlantilla}
              >
                <IconFileDownload size={16} />
              </ActionIcon>
            </Tooltip>
            <Tooltip zIndex={100000} label="Carga Masiva" style={{ fontSize: '10px', padding: '3px 5px' }} withinPortal openDelay={100}>
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={cargaMasivaMateriales}
              >
                <IconCloudUpload size={16} />
              </ActionIcon>
            </Tooltip>

          </Group>

          <Button
            color="primary"
            variant="light"
            size='xs'
            leftSection={<IconPlus color="var(--mantine-color-primary-0)" size={12} />}
            radius="lg"
            onClick={() => abrirModalMaterial(true, estadoInicialMaterial)}
            disabled={filaEnEdicion !== null}
          >
            <Text fw={500} size="xs">Agregar Material</Text>
          </Button>
        </Group>
      </Group>
      {habilitarFiltros && (
        <FiltroMaterialesVista
          consultarMateriales={consultarMateriales}
          filtro={filtro}
          manejarCambioFiltroMaterial={manejarCambioFiltroMaterial}
          tiposMateriales={tiposMateriales}
          limpiarFiltros={limpiarFiltros}
        />
      )}
      <div style={{ flex: 1, minHeight: 0 }}>
        <Tabla
          tabla={tabla}
          modoEdicion={modoEdicionLinea}
          filaEnEdicion={filaEnEdicion?.toString() ?? null} // ✅ Convertir a string para la tabla
        />
      </div>
    </div>
  );
};

export default React.memo(TablaMaterialesVista);